import React from 'react';
import Dropzone from 'react-dropzone';
import { SERVER_URL } from '../../config';
import PortalAttachmentsList from './PortalAttachmentsList';
import FormRootLayout from './FormRootLayout';

const PortalIndexAttachments = ({
	portal,
	translate,
	refetch,
	updateAndSave
}) => {
	const onDrop = React.useCallback(files => {
		if (!files) {
			return;
		}

		files.forEach(file => {
			const reader = new FileReader();
			reader.readAsBinaryString(file);

			reader.onload = async () => {
				const formData = new FormData();
				formData.append('file', file);
				formData.append('data', JSON.stringify({
					portalId: portal.id,
				}));

				const xhr = new XMLHttpRequest();
				xhr.onload = function (e) {
					console.log(e);
				};

				xhr.onreadystatechange = function () {
					if (xhr.readyState === 4) {
						refetch();
					}
				};

				xhr.upload.onprogress = function (e) {
					if (e.loaded === e.total) {
						// setTimeout(refetch, 500);
						// refetch();
					} else {
						// updateQueueItem(((e.loaded / e.total) * 100).toFixed(2), id);
					}
				};
				xhr.open('POST', `${SERVER_URL}/api/councilPortalAttachment`, true);
				xhr.setRequestHeader('x-jwt-token', sessionStorage.getItem('token'));
				xhr.send(formData);
			};
		});
	}, [portal.attachments]);


	const renderForm = () => (
		<div style={{ marginBottom: '1em' }}>
			<h5>Documentos adjuntos</h5>
			<div style={{ marginBottom: '1em' }}>
				<Dropzone
					onDrop={onDrop}
					multiple={true}
				// accept="application/pdf"
				>
					{({ getRootProps, getInputProps }) => (
						<>
							<div
								{...getRootProps()}
								className={'dropzone'}
								style={{
									minHeight: '8em',
									border: '2px dashed gainsboro',
									borderRadius: '3px',
									cursor: 'pointer'
								}}
							>
								<input {...getInputProps()} />
								<div style={{ padding: '1em' }}>
									<PortalAttachmentsList
										portal={portal}
										refetch={refetch}
										translate={translate}
										deleteButton={true}
										downloadButton={true}
										editButton={true}
										updateState={config => updateAndSave({
											config
										})}
									/>
								</div>
							</div>
						</>
					)}
				</Dropzone>
			</div>
		</div>
	);

	return (
		<FormRootLayout
			stylesHeight={{ height: 'calc( 100% - 7em )' }}
			form={renderForm()}
		/>
	);
};


export default PortalIndexAttachments;

